<template>
    <div class="tabletSlide">
        <div class="row counterDeals py-3">
                
                <div class="d-flex price-card">
                    <span class="font-11 first-line">{{$ml.get('NUMBER_OF_OPEN_DEALS')}}<br/>
                    <b class="font-md" v-if="dashBoard.find(info=>info._id==1)!=null">{{dashBoard.find(info=>info._id==1).count}}</b><b class="font-md" v-else>0</b></span>
                    <span class="font-40 m-font-26 smile-up"><i class="fa fa-smile-o"></i></span>
                </div>
                <v-popover  popoverClass="currencypop" :trigger="popoverTrigger" :delay="popoverDelay">
                    <div class="d-flex price-card">
                        <span class="font-11 first-line">{{$ml.get('AMOUNT_OF_OPEN_DEALS')}}<br/>
                        <b class="font-md" v-if="dashBoard.find(info=>info._id==1)!=null">{{formatPrice(dashBoard.find(info=>info._id==1).totalValue)}}</b><b class="font-md" v-else>0</b></span>
                        <span class="font-40 m-font-26 smile-up"><i class="fa fa-smile-o"></i></span>
                    </div>
                    <template #popover>
                        <label class="font-weight-bold p-list-title">{{$ml.get('PRICE_LIST')}}</label>
                        <ul class="list-group list-group-flush price-list ">
                            <li class="list-group-item" v-for="(currency,index) in currenciesList(1)" v-bind:key="index"><div class="d-flex"><div class="curr-shortcode">{{currencyLabel(currency.currency)}}: {{currency.count}}</div><div>{{$ml.get('DEALS_TOTAL')}}</div><div class="ml-auto">{{currencySymbol(currency.currency)}} {{formatPrice(currency.price)}}</div></div></li>
                        </ul>
                    </template>
                </v-popover>
                <div class="d-flex price-card winDealsCount transtion">
                    <span class="font-11 first-line">{{$ml.get('NUMBER_OF_WON_DEALS')}}<br/>
                    <b class="font-md" v-if="dashBoard.find(info=>info._id==2)!=null">{{dashBoard.find(info=>info._id==2).count}}</b><b class="font-md" v-else>0</b></span>
                    <span class="font-40 m-font-26 smile-up"><i class="fa fa-smile-o"></i></span>
                </div>
                <v-popover  popoverClass="currencypop" :trigger="popoverTrigger" :delay="popoverDelay">
                    <div class="d-flex price-card winDealsPrice transtion">
                        <span class="font-11 first-line">{{$ml.get('AMOUNT_OF_WON_DEALS')}}<br/>
                        <b class="font-md" v-if="dashBoard.find(info=>info._id==2)!=null">{{formatPrice(dashBoard.find(info=>info._id==2).totalValue)}}</b><b class="font-md" v-else>0</b></span>
                        <span class="font-40 m-font-26 smile-up"><i class="fa fa-smile-o"></i></span>
                    </div>
                    <template #popover>
                        <label class="font-weight-bold p-list-title">{{$ml.get('PRICE_LIST')}}</label>
                        <ul class="list-group list-group-flush price-list ">
                            <li class="list-group-item" v-for="(currency,index) in currenciesList(2)" v-bind:key="index"><div class="d-flex"><div class="curr-shortcode">{{currencyLabel(currency.currency)}}: {{currency.count}}</div><div>{{$ml.get('DEALS_TOTAL')}}</div><div class="ml-auto">{{currencySymbol(currency.currency)}} {{formatPrice(currency.price)}}</div></div></li>
                        </ul>
                    </template>
                </v-popover>
                <div class="d-flex price-card notwinDealsCount transtion">
                    <span class="font-11 first-line">{{$ml.get('NUMBER_OF_LOST_DEALS')}}<br/>
                    <b class="font-md" v-if="dashBoard.find(info=>info._id==3)!=null">{{dashBoard.find(info=>info._id==3).count}}</b><b class="font-md" v-else>0</b></span>
                    <span class="font-40 m-font-26 smile-up"><i class="fa fa-frown-o"></i></span>
                </div>
                <v-popover  popoverClass="currencypop" :trigger="popoverTrigger" :delay="popoverDelay">
                    <div class="d-flex price-card notwinDealsPrice transtion">
                        <span class="font-11 first-line">{{$ml.get('AMOUNT_OF_LOST_DEALS')}}<br/>
                        <b class="font-md" v-if="dashBoard.find(info=>info._id==3)!=null">{{formatPrice(dashBoard.find(info=>info._id==3).totalValue)}}</b><b class="font-md" v-else>0</b></span>
                        <span class="font-40 m-font-26 smile-up"><i class="fa fa-frown-o"></i></span>
                    </div>
                    <template #popover>
                        <label class="font-weight-bold p-list-title">{{$ml.get('PRICE_LIST')}}</label>
                        <ul class="list-group list-group-flush price-list ">
                            <li class="list-group-item" v-for="(currency,index) in currenciesList(3)" v-bind:key="index"><div class="d-flex"><div class="curr-shortcode">{{currencyLabel(currency.currency)}}: {{currency.count}}</div><div>{{$ml.get('DEALS_TOTAL')}}</div><div class="ml-auto">{{currencySymbol(currency.currency)}} {{formatPrice(currency.price)}}</div></div></li>
                        </ul>
                    </template>
                </v-popover>
            </div>
    </div>
</template>
<script>
export default {
    name:"dealsDashBoard",
    props:['dashBoard'],
    data() {
        return {
            popoverDelay:{ show: 500, hide: 300 },
            popoverTrigger:"hover"
        }
    },
    methods: {
        currenciesList(id){
            var list = this.dashBoard.find(info=>info._id==id)
            if(list){
                return list.prices
            }else{
                return []
            }
        },
        formatPrice: function(val){
            if(val!==undefined){
                return val.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1\,")
            }
        },
    }
}
</script>
<style scoped>
.price-list > .list-group-item{
    padding:5px;
}
.price-list .curr-shortcode{
    width: 25%;
}
.p-list-title{
    padding-left:5px;
}
.v-popover{
    cursor:context-menu;
}
.price-card{
    position: relative;
    padding: 18px 9px;
    border-radius: 4px;
}
.price-card .first-line {
    width: 100%;
    word-break: break-word;
}
.smile-up{
    position: absolute;
    top: 4px;
    right: 12px;
}
@media (max-width: 768px) {
    .price-card{
        padding: 8px;
    }
}
</style>
